﻿// Set for deletion (to global)

window.main = function () {
    return {

        setHideDiv: function (id, show, inverse) {
            var showBool = show;
            if (typeof show === "string" || show instanceof String) {
                showBool = show.toLowerCase() === "true";
            }

            if (inverse !== undefined && inverse) {
                showBool = !showBool;
            }

            var element = $("#" + id);

            if (element !== undefined && element !== null) {

                if (element.style != undefined) {
                    if (showBool) {
                        element.style.visibility = "block";  // "inline";
                    } else {
                        element.style.visibility = "none";
                    }
                } else {
                    element[0].hidden = !showBool;
                }

            }

            $("#" + id + " input").attr("data-validate", showBool);
        },

        setHideDivBootstrap: function (id, show, inverse) {
            var showBool = show;
            if (typeof show === "string" || show instanceof String) {
                showBool = show.toLowerCase() === "true";
            }

            if (inverse !== undefined && inverse) {
                showBool = !showBool;
            }

            var element = $("#" + id);

            if (element !== undefined && element !== null) {

                if (showBool) {
                    element.removeClass('d-none');
                } else {
                    element.addClass('d-none');
                }
            }

        },

        setHideKendoUIFormItem: function (id, show, inverse) {
            var showBool = show;
            if (typeof show === "string" || show instanceof String) {
                showBool = show.toLowerCase() === "true";
            }

            if (inverse !== undefined && inverse) {
                showBool = !showBool;
            }

            var element = $("#" + id).closest("div").parent().closest("div");

            if (element !== undefined && element !== null) {

                if (showBool) {
                    element.css("display", "inline-flex");
                } else {
                    element.css("display", "none");
                }
            }

        },

        //
        // This method uses the hidden attribute to hide form controls
        // 
        setHideKendoUIFormItem2: function (id, show) {

            var element = document.getElementById(id).parentElement.parentElement.closest("div.k-form-field");

            if (element !== undefined && element !== null) {

                if (show) {
                    // remove attribute 'hidden'
                    element.removeAttribute("hidden");
                } else {
                    // add attribute 'hidden'
                    element.setAttribute("hidden", "hidden");
                }
            }
        },

        //
        // This method uses the hidden attribute of the first div above the input (id) and of the label (id+'-form-label') to hide form controls
        // 
        setHideKendoUIFormItem3: function (id, show) {

            var element = document.getElementById(id).parentElement.parentElement;

            if (element !== undefined && element !== null) {

                if (show) {
                    // remove attribute 'hidden'
                    element.removeAttribute("hidden");
                } else {
                    // add attribute 'hidden'
                    element.setAttribute("hidden", "hidden");
                }
            }

            // label
            var id2 = id + "-form-label";
            element = document.getElementById(id2);

            if (element !== undefined && element !== null) {

                if (show) {
                    // remove attribute 'hidden'
                    element.removeAttribute("hidden");
                } else {
                    // add attribute 'hidden'
                    element.setAttribute("hidden", "hidden");
                }
            }
        },

        //
        // For taghelper items not in taghelper-form, form with bootstrap
        //
        setHideKendoUIFormItem4: function (id, show) {

            var element = document.getElementById(id);

            if (element != null && element != undefined) {

                if (show) {
                    // remove attribute 'hidden'
                    element.parentElement.parentElement.removeAttribute("hidden");
                } else {
                    // add attribute 'hidden'
                    element.parentElement.parentElement.setAttribute("hidden", "hidden");
                }
            }

            // label
            var id2 = id + "_label";
            element = document.getElementById(id2);

            if (element != null && element != undefined) {

                if (show) {
                    // remove attribute 'hidden'
                    element.removeAttribute("hidden");
                } else {
                    // add attribute 'hidden'
                    element.setAttribute("hidden", "hidden");
                }
            }
        },

        //
        // Hides an element directly below a div
        //
        setHideKendoUIFormItem5: function (id, show) {

            var element = document.getElementById(id);

            if (element != null && element != undefined) {

                if (show) {
                    // remove attribute 'hidden'
                    element.parentElement.removeAttribute("hidden");
                } else {
                    // add attribute 'hidden'
                    element.parentElement.setAttribute("hidden", "hidden");
                }
            }
        },

        getKendoCheckBoxGroupValue: function (cg_ID) {
            var result = 0;
            var cg = $("#" + cg_ID).getKendoCheckBoxGroup();
            if (cg != null && cg != undefined) {
                var cg_ValArr = cg.value();
                for (var i = 0; i < cg_ValArr.length; i++) {
                    result += parseInt(cg_ValArr[i]);
                }
            }
            return result;
        },

        makeResultMessage: function (responseData) {

            var color = 'black';
            if (responseData == undefined || responseData == null) {
                $('#Validation').text('');
            }
            else {
                if (responseData.Succesfully != undefined) {
                    color = (responseData.Succesfully ? 'blue' : 'red');
                    if (responseData.Message == undefined || responseData.Message == null) {
                        responseData.Message = (responseData.Succesfully ? "Saved" : "Error");         // TODO: translate
                    }
                    $('#Validation').attr('style', 'color:' + color);
                    $('#Validation').text(responseData.Message);
                }
            }
            return color;
        },

        /*--- dialog popup ---*/
        openActionsDialog: function (titleDialog, contentDialog, actions, height, width, cssclass) {
            titleDialog = main.decodeHtmlEntity(unescape(titleDialog));
            contentDialog = main.decodeHtmlEntity(unescape(main.replaceAll(contentDialog, "\r\n", "<br />")));
            main.addDialogDiv();
            if (height == undefined || !height > 0) { height = 160; }
            if (width == undefined || !width > 0) { width = 450; }
            $("#dialog").kendoDialog({
                modal: true,
                title: titleDialog,
                resizable: false,
                height: height,
                width: width,
                content: contentDialog,
                actions: actions
            });

            // draggable is unknown ?
            // $(".k-dialog").draggable({ handle: ".k-dialog-titlebar", containment: "parent" });
            if (cssclass != undefined) { $("#dialog").addClass(cssclass); }
            $("button.k-button.k-button-md.k-rounded-md.k-button-solid.k-button-solid-primary").focus();
        },

        decodeHtmlEntity: function (str) {
            return str.replace(/&#(\d+);/g, function (match, dec) {
                return String.fromCharCode(dec);
            });
        },

        replaceAll: function (valueStr, search, replacement) {
            if (valueStr != undefined || valueStr != null) {
                return valueStr.split(search).join(replacement);
            } else { 
                return valueStr;
            }
        },

        addDialogDiv: function () {
            if ($("#dialog").length == 0) { $(document.body).append("<div id='dialog'></div>"); }
            else { $("#dialog").html(""); }
        },

        openPopup: function () {
            $("#dialog").data("kendoDialog").open();
        },

        closePopup: function () {
            if ($("#dialog").data("kendoDialog") !== undefined && $("#dialog").data("kendoDialog") !== null) {
                $("#dialog").data("kendoDialog").close();
            }

            kendo.destroy($("#dialog"));
        }

    }
}();

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function getTargetFromUrl(url) {
    return getParameterByName("target", url);
}
var numberrequests = 0;
var timeoutExecution;

$(function () {
    $.xhrPool = [];
    $.xhrPool.abortAllOnError = function () {
        $(this).each(function (i, jqXHR) {   //  cycle through list of recorded connection
            if (jqXHR.responseText !== undefined && jqXHR.responseText.indexOf('Account/Login') === -1) {
                jqXHR.abort();  //  aborts connection
                $.xhrPool.splice(i, 1); //  removes from list by index
            }
        });
    };
    $.xhrPool.abortAll = function () {
        $(this).each(function (i, jqXHR) {   //  cycle through list of recorded connection
            jqXHR.abort();  //  aborts connection
            $.xhrPool.splice(i, 1); //  removes from list by index
        });
    };
    //Abort pending requests on the same target(pane)
    $.xhrPool.abortByTarget = function (target) {
        if (target !== undefined && target !== null && target !== "") {
            $(this).each(function (i, jqXHR) {   //  cycle through list of recorded connection
                if (jqXHR.target == target) {
                    jqXHR.abort();  //  aborts connection
                    $.xhrPool.splice(i, 1); //  removes from list by index
                }
            });
        }
    };
    $.ajaxSetup({
        beforeSend: function (jqXHR) {
            jqXHR.target = getTargetFromUrl(this.url);
            var showLoadIndicator = true; // default show load indicator
            // get parameter if disabled.
            if (this.disableLoadIndicator === true) {
                showLoadIndicator = false;
            }
            $.xhrPool.abortByTarget(jqXHR.target);
            $.xhrPool.push(jqXHR);
            // clean any tooltip (can cause future problems including not responding tooltips elsewhere).
            $('.k-chart-tooltip').remove();
            // When enabled (load indicator)
            if (showLoadIndicator) {
                // Load indicator jquery ajax calls (first)
                if (numberrequests <= 0) {
                    numberrequests = 0; // reset!
                    kendo.ui.progress($("#moduleLayout"), true);
                    clearTimeout(timeoutExecution);
                    timeoutExecution = setTimeout(function () { numberrequests = 0; kendo.ui.progress($("#moduleLayout"), false); }, 30000);
                }
                numberrequests++;
            }
        },
        error: function () {
            $.xhrPool.abortAllOnError();
            clearTimeout(timeoutExecution);
        },
        complete: function (jqXHR) {
            var i = $.xhrPool.indexOf(jqXHR);   //  get index for current connection completed
            if (i > -1) $.xhrPool.splice(i, 1); //  removes from list by index
            numberrequests--;
            if (numberrequests <= 0) {
                numberrequests = 0;
                kendo.ui.progress($("#moduleLayout"), false);
                clearTimeout(timeoutExecution);
            }
        }
    })
})
